import { FilterProps } from 'pages/PackSite/types/packsiteLog';
import { ProductionPackSiteProps } from 'types/productionPackSite';
import moment from 'moment';


export function getPackSiteCellData(packsite:ProductionPackSiteProps) {
  const { 
    systemIds,
    packSite,
    distributionDepot,
    targetERP,
  } = packsite;

  const returnArray = [{
    label: 'Distribution Id',
    value: distributionDepot,
  },
  {
    label: 'Packsite',
    value: packSite,
  },
  {
    label: 'TargetERP',
    value: targetERP,
  }];

  if (systemIds) {
    returnArray.push({
      label: `${systemIds[0].systemId} Item`,
      value: systemIds[0].itemId,
    },
    {
      label: 'PIN Code',
      value: systemIds[1].itemId,
    },
    {
      label: `${systemIds[2].systemId} Item`,
      value: systemIds[2].itemId,
    },
    )
  }
  return returnArray;
}

export function mutateFilters(filters: FilterProps) {
  const {
    limit,
    offSet,
    supplierId,
    MFGItem,
    customerId,
    operatingUnit,
  } = filters;

  return {
    limit,
    offSet,
    supplierId,
    MFGItem,
    customerId,
    operatingUnit,
  }
}

export function mutateFiltersGet(filters: FilterProps) {
  const {
    limit,
    offSet,
    supplierId,
    MFGItem,
    RMSitemId,
    SMSitemId,
    customerId,
    operatingUnit,
    packSite,
    itemDescription,
    dateEffectiveFrom,
    dateEffectiveTo,
  } = filters;

  return {
    limit,
    offSet,
    supplierId,
    MFGItem,
    RMSitemId,
    SMSitemId,
    customerId,
    operatingUnit,
    packSite,
    itemDescription,
    dateEffectiveFrom: dateEffectiveFrom ? moment(dateEffectiveFrom).format('YYYY-MM-DD') : null,
    dateEffectiveTo: dateEffectiveTo ? moment(dateEffectiveTo).format('YYYY-MM-DD') : null,
  }
}

export function mutatePackSite(data: ProductionPackSiteProps) {
  const {
    supplierId,
    manufacturingCompany,
    operatingUnit,
    distributionDepot,
    ruleType,
    ruleFromDate,
    ruleToDate,
    packSite,
    targetERP,
    systemIds,
    itemDescription,
  } = data;
  return {
    systemIds,
    itemDescription,
    operatingUnit,
    ruleType,
    distributionDepot,
    manufacturingCompany,
    supplierId,
    packSite,
    targetERP,
    ruleFromDate: ruleFromDate ? moment(ruleFromDate).format('YYYY-MM-DD') : null,
    ruleToDate: ruleToDate ? moment(ruleToDate).format('YYYY-MM-DD') : null,
  }
}

export function mutatePackSiteForModal(data: ProductionPackSiteProps) {
  const {
    supplierId,
    manufacturingCompany,
    operatingUnit,
    distributionDepot,
    ruleType,
    ruleFromDate,
    ruleToDate,
    packSite,
    targetERP,
    systemIds,
    itemDescription,
    indexId,
  } = data;
  return {
    systemIds,
    itemDescription,
    operatingUnit,
    ruleType,
    distributionDepot,
    manufacturingCompany,
    supplierId,
    packSite,
    targetERP,
    ruleFromDate: ruleFromDate ? moment(ruleFromDate).format('DD MMM YYYY') : null,
    ruleToDate: ruleToDate ? moment(ruleToDate).format('DD MMM YYYY') : null,
    indexId,
  }
}

export function isAlphanumeric(data: string) {
  return data.match(/^[0-9a-z]+$/i);
}
